import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';

const Dropdown = ({
  options,
  onSelection,
  children,
  prevSelection,
  index,
  disabled,
}) => {
  const intl = useIntl();
  const [active, setActive] = useState('');
  const [block, setBlock] = useState({ display: 'none' });
  const [selected, setSelected] = useState(
    prevSelection ? prevSelection : 'notSelected',
  );

  const onClick = () => {
    if (active === 'active') {
      setActive('');
      setBlock({ display: 'none' });
    } else {
      setActive('active');
      setBlock({ display: 'block' });
    }
  };

  const updateSelection = (indexSelection, value, indexOriginal) => {
    setSelected(value);
    onSelection(indexSelection, value, indexOriginal);
  };

  return (
    <div style={{ display: 'flex' }} id={`attr.${selected}`}>
      <div className="select" style={{ background: 'white' }} onClick={onClick}>
        <div style={{ height: '48px' }} className={'select-styled ' + active}>
          {intl.formatMessage({ id: `attr.${selected}` })}
        </div>
        <ul className="select-options" style={block}>
          {options.map((option, ind) => {
            return option ? (
              <li
                key={`${ind}-${option}`}
                id={`${ind}-${option}`}
                onClick={() => updateSelection(ind, option, index)}
              >
                {intl.formatMessage({ id: `attr.${option}` })}
              </li>
            ) : null;
          })}
        </ul>
      </div>
      <input type="hidden" name="region" id="input-region" value="" />
      {children}
    </div>
  );
};

Dropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelection: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
  prevSelection: PropTypes.string,
  index: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
};

Dropdown.defaultProps = {
  prevSelection: undefined,
};

export default Dropdown;
